module.exports = __webpack_public_path__ + "img/xw.df5549f8.jpg";